import { useState, useEffect } from "react";
import { Search, Star } from "lucide-react";
import { fmtPrice, pct, clsx } from "../lib/format";
import { Input } from "./ui/input";

export default function MarketWatch({ assets, prices, selected, onSelect }) {
  const [q, setQ] = useState("");
  const [favs, setFavs] = useState(() => JSON.parse(localStorage.getItem("fx_favs") || "[]"));
  const [tab, setTab] = useState("all");

  useEffect(() => { localStorage.setItem("fx_favs", JSON.stringify(favs)); }, [favs]);

  const toggleFav = (sym) => setFavs((f) => (f.includes(sym) ? f.filter((s) => s !== sym) : [...f, sym]));

  let list = assets.filter((a) => a.symbol.toLowerCase().includes(q.toLowerCase()) || a.name.toLowerCase().includes(q.toLowerCase()));
  if (tab === "favs") list = list.filter((a) => favs.includes(a.symbol));

  return (
    <div className="flex flex-col h-full">
      <div className="p-3 border-b border-white/5 space-y-3">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-fx-s3" />
          <Input data-testid="market-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search markets" className="pl-9 h-9 bg-fx-base border-white/10 text-sm" />
        </div>
        <div className="flex gap-1">
          {[["all", "All"], ["favs", "Favorites"]].map(([k, l]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`market-tab-${k}`}
              className={clsx("px-3 py-1 rounded-md text-xs font-medium transition-colors", tab === k ? "bg-brandblue/20 text-brandblue" : "text-fx-s3 hover:text-white")}>
              {l}
            </button>
          ))}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        {list.length === 0 && <div className="p-6 text-center text-fx-s3 text-sm">No markets found.</div>}
        {list.map((a) => {
          const price = prices?.[a.symbol] ?? a.price;
          const active = selected === a.symbol;
          return (
            <button
              key={a.symbol}
              onClick={() => onSelect(a.symbol)}
              data-testid={`market-row-${a.symbol.replace("/", "-")}`}
              className={clsx("w-full flex items-center gap-2 px-3 py-2.5 border-b border-white/[0.03] text-left transition-colors", active ? "bg-brandblue/10" : "hover:bg-white/[0.03]")}
            >
              <span onClick={(e) => { e.stopPropagation(); toggleFav(a.symbol); }} className="shrink-0" data-testid={`fav-${a.symbol.replace("/", "-")}`}>
                <Star className={clsx("h-4 w-4", favs.includes(a.symbol) ? "fill-gold text-gold" : "text-fx-s3")} />
              </span>
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-sm text-white truncate">{a.symbol}</div>
                <div className="text-[11px] text-fx-s3 truncate">{a.name}</div>
              </div>
              <div className="text-right">
                <div className="font-mono text-sm text-white">{fmtPrice(price)}</div>
                <div className={clsx("font-mono text-[11px]", a.change_24h >= 0 ? "text-pos" : "text-neg")}>{pct(a.change_24h)}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
